const INGESTOR_URL = process.env.VUE_APP_INGESTOR_URL || 'https://ingestor.basboard.com/api/track'
const INGESTOR_TOKEN = process.env.VUE_APP_INGESTOR_WRITE_TOKEN || ''
const APP_VERSION = process.env.VUE_APP_VERSION || process.env.VUE_APP_GIT_SHA || ''
const DEVICE_ID_KEY = 'lebron_analytics_device_id'
const SESSION_ID_KEY = 'lebron_analytics_session_id'

function safeStorageGet(key) {
  try {
    return window.localStorage.getItem(key)
  } catch (e) {
    return null
  }
}

function safeStorageSet(key, value) {
  try {
    window.localStorage.setItem(key, value)
  } catch (e) {
    // Ignore storage failures in private mode or restricted webviews.
  }
}

function randomId() {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID()
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`
}

function getDeviceId() {
  let deviceId = safeStorageGet(DEVICE_ID_KEY)
  if (!deviceId) {
    deviceId = randomId()
    safeStorageSet(DEVICE_ID_KEY, deviceId)
  }
  return deviceId
}

function getSessionId() {
  let sessionId = safeStorageGet(SESSION_ID_KEY)
  if (!sessionId) {
    sessionId = randomId()
    safeStorageSet(SESSION_ID_KEY, sessionId)
  }
  return sessionId
}

function normalizeProperties(properties) {
  return Object.keys(properties || {}).reduce((result, key) => {
    const value = properties[key]
    if (value !== undefined && value !== null) {
      result[key] = value
    }
    return result
  }, {})
}

function track(event, properties) {
  if (!INGESTOR_TOKEN || !INGESTOR_URL) {
    return
  }

  const payload = {
    event,
    eventId: randomId(),
    ts: new Date().toISOString(),
    sessionId: getSessionId(),
    platform: 'web',
    appVersion: APP_VERSION || undefined,
    properties: normalizeProperties({
      ...properties,
      deviceId: getDeviceId(),
      page: window.location.pathname,
      search: window.location.search,
      referrer: document.referrer,
      language: navigator.language,
      userAgent: navigator.userAgent
    })
  }

  window.fetch(INGESTOR_URL, {
    method: 'POST',
    keepalive: true,
    headers: {
      Authorization: `Bearer ${INGESTOR_TOKEN}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  }).catch(() => {
    // Analytics must never interrupt the page flow.
  })
}

function trackPageView(route, fromRoute) {
  track('lebron_page_view', {
    routeName: route && route.name,
    path: route && route.path,
    fullPath: route && route.fullPath,
    fromPath: fromRoute && fromRoute.fullPath,
    title: document.title
  })
}

export default {
  track,
  trackPageView
}
